module.exports = __webpack_public_path__ + "img/stada_logo_cmyk_color.4704fa1a.png";